import {
  Label1,
  Label2,
  Label3,
  Label4,
  Tab,
  Para,
  Caption,
  SmallCaption,
  Strong
} from "./Labels"

export {
  Label1,
  Label2,
  Label3,
  Label4,
  Tab,
  Para,
  Caption,
  SmallCaption,
  Strong
}
